// Auto-generated per-query builders for Action
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ActionReadAPI, ActionWriteAPI, ActionReadAPISchema, ActionWriteAPISchema } from '../types/action';
import { ModelRegistry } from '../../registries/model-registry';
import { ActionBindsParameter, ActionHasInputParameters, ActionHasOutputParameters, ActionVerifiesRequirement, AtScope, ContainsAction, HasAttribute, HasAttributeValue, HasDerivedValue, Mentions, OwnedByUser, RFLPPerforms, Satisfies, SuccessionSourceAction, SuccessionTargetAction } from '../../relationships/relationship';

import { Requirement } from './requirement';
import { LogicalPart } from './logicalpart';
import { ActionInputParameter } from './actioninputparameter';
import { ActionOutputParameter } from './actionoutputparameter';
import { ActionParameter } from './actionparameter';
import { Succession } from './succession';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { User } from '../../base/api/user';





// Builder chain for query: rflp-action-by-id

export interface RflpActionByIdBuilder_0 {
  get(id: string): RflpActionByIdBuilder_1;
  filter(conditions: { id: string }): RflpActionByIdBuilder_1;
}

export interface RflpActionByIdBuilder_1 {
  all(): Promise<Action[]>;
  first(): Promise<Action | null>;
  get(): Promise<Action[]>;
  execute(): Promise<Action[]>;
}


// Union of all query entry points
export type ActionQueryBuilder = RflpActionByIdBuilder_0;

// Available query names for .setQuery()
export type ActionQueryNames = "rflp-action-by-id";

// Type narrowing for .setQuery()
export type ActionBuilderForQuery<Q extends ActionQueryNames> =
  Q extends "rflp-action-by-id" ? RflpActionByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ActionInstanceQueryResult<Q extends ActionQueryNames> =
  Q extends "rflp-action-by-id" ? RflpActionByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-action-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ActionQueryNames>(queryName: Q): ActionBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface Action extends Partial<ActionReadAPI> {}
export class Action extends NeoNodeBase<ActionReadAPI, ActionWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Action";
  static readonly readSchema = ActionReadAPISchema;
  static readonly writeSchema = ActionWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    responsible_user: { target: "User", cardinality: "one", isParent: false, relClass: "OwnedByUser", direction: "out" },
    parent: { target: "LogicalPart", cardinality: "one", isParent: true, relClass: "ContainsAction", direction: "in" },
    sub_actions: { target: "Action", cardinality: "many", isParent: false, relClass: "ContainsAction", direction: "out" },
    satisfies: { target: "Requirement", cardinality: "many", isParent: false, relClass: "Satisfies", direction: "out" },
    verifies: { target: "Requirement", cardinality: "many", isParent: false, relClass: "ActionVerifiesRequirement", direction: "out" },
    performed_by: { target: "LogicalPart", cardinality: "many", isParent: false, relClass: "RFLPPerforms", direction: "in" },
    input_parameters: { target: "ActionInputParameter", cardinality: "many", isParent: false, relClass: "ActionHasInputParameters", direction: "out" },
    output_parameters: { target: "ActionOutputParameter", cardinality: "many", isParent: false, relClass: "ActionHasOutputParameters", direction: "out" },
    bound_parameters: { target: "ActionParameter", cardinality: "many", isParent: false, relClass: "ActionBindsParameter", direction: "out" },
    outgoing_successions: { target: "Succession", cardinality: "many", isParent: false, relClass: "SuccessionSourceAction", direction: "in" },
    incoming_successions: { target: "Succession", cardinality: "many", isParent: false, relClass: "SuccessionTargetAction", direction: "in" },
  };

  protected get modelName(): string {
    return 'Action';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Action.label;
  }


  constructor(data: Partial<ActionWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ActionReadAPI, loadContext?: Record<string, any>): Action {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { parent, sub_actions, satisfies, verifies, performed_by, input_parameters, output_parameters, bound_parameters, outgoing_successions, incoming_successions, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, responsible_user, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ActionReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, parent: parent, sub_actions: sub_actions, satisfies: satisfies, verifies: verifies, performed_by: performed_by, input_parameters: input_parameters, output_parameters: output_parameters, bound_parameters: bound_parameters, outgoing_successions: outgoing_successions, incoming_successions: incoming_successions, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, responsible_user: responsible_user };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Action.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'parent', 'LogicalPart', ModelRegistry);
    loadManyRelationship(processed, 'sub_actions', 'Action', ModelRegistry);
    loadManyRelationship(processed, 'satisfies', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'verifies', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'performed_by', 'LogicalPart', ModelRegistry);
    loadManyRelationship(processed, 'input_parameters', 'ActionInputParameter', ModelRegistry);
    loadManyRelationship(processed, 'output_parameters', 'ActionOutputParameter', ModelRegistry);
    loadManyRelationship(processed, 'bound_parameters', 'ActionParameter', ModelRegistry);
    loadOneRelationship(processed, 'outgoing_successions', 'Succession', ModelRegistry);
    loadOneRelationship(processed, 'incoming_successions', 'Succession', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadOneRelationship(processed, 'responsible_user', 'User', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Action(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ActionQueryBuilder {
    return new QueryBuilderImpl('Action').filter(conditions) as any;
  }

  static all(): ActionQueryBuilder {
    return new QueryBuilderImpl('Action') as any;
  }

  static async first(): Promise<Action | null> {
    const results = await new QueryBuilderImpl('Action').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ActionQueryNames>(queryName: Q): ActionBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Action');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ActionQueryNames>(queryName: Q): ActionInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Action.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const action = await Action.get(id).first();
   * await action.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await action.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'satisfies' - Python ORM style (cached)
  get satisfies(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('satisfies', () => {
      return new RelationshipManager(this, 'satisfies', 'many', Satisfies as typeof Relationship);
    });
  }

  // Relationship manager for 'verifies' - Python ORM style (cached)
  get verifies(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('verifies', () => {
      return new RelationshipManager(this, 'verifies', 'many', ActionVerifiesRequirement as typeof Relationship);
    });
  }

  // Relationship manager for 'performed_by' - Python ORM style (cached)
  get performed_by(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('performed_by', () => {
      return new RelationshipManager(this, 'performed_by', 'many', RFLPPerforms as typeof Relationship);
    });
  }

  // Relationship manager for 'input_parameters' - Python ORM style (cached)
  get input_parameters(): RelationshipManager<this, ActionInputParameter> {
    return this.getOrCreateRelationshipManager('input_parameters', () => {
      return new RelationshipManager(this, 'input_parameters', 'many', ActionHasInputParameters as typeof Relationship);
    });
  }

  // Relationship manager for 'output_parameters' - Python ORM style (cached)
  get output_parameters(): RelationshipManager<this, ActionOutputParameter> {
    return this.getOrCreateRelationshipManager('output_parameters', () => {
      return new RelationshipManager(this, 'output_parameters', 'many', ActionHasOutputParameters as typeof Relationship);
    });
  }

  // Relationship manager for 'bound_parameters' - Python ORM style (cached)
  get bound_parameters(): RelationshipManager<this, ActionParameter> {
    return this.getOrCreateRelationshipManager('bound_parameters', () => {
      return new RelationshipManager(this, 'bound_parameters', 'many', ActionBindsParameter as typeof Relationship);
    });
  }

  // Relationship manager for 'outgoing_successions' - Python ORM style (cached)
  get outgoing_successions(): RelationshipManager<this, Succession> {
    return this.getOrCreateRelationshipManager('outgoing_successions', () => {
      return new RelationshipManager(this, 'outgoing_successions', 'many', SuccessionSourceAction as typeof Relationship);
    });
  }

  // Relationship manager for 'incoming_successions' - Python ORM style (cached)
  get incoming_successions(): RelationshipManager<this, Succession> {
    return this.getOrCreateRelationshipManager('incoming_successions', () => {
      return new RelationshipManager(this, 'incoming_successions', 'many', SuccessionTargetAction as typeof Relationship);
    });
  }

  // Relationship manager for 'parent' - Python ORM style (cached)
  get parent(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('parent', () => {
      return new RelationshipManager(this, 'parent', 'many', ContainsAction as typeof Relationship);
    });
  }

  // Relationship manager for 'sub_actions' - Python ORM style (cached)
  get sub_actions(): RelationshipManager<this, Action> {
    return this.getOrCreateRelationshipManager('sub_actions', () => {
      return new RelationshipManager(this, 'sub_actions', 'many', ContainsAction as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'responsible_user' - Python ORM style (cached)
  get responsible_user(): RelationshipManager<this, User> {
    return this.getOrCreateRelationshipManager('responsible_user', () => {
      return new RelationshipManager(this, 'responsible_user', 'one', OwnedByUser as typeof Relationship);
    });
  }

}
